module.exports = __webpack_public_path__ + "public/img/冷却水流量.341ca77c.png";